const styleElement = document.createElement("dom-module");

styleElement.innerHTML = /*html*/`<template>
  <style>
    :host {
      display: block;
      width: 100%;
    }

    .limited-access-composer {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
      width: 100%;
      padding: 16px 18px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 18px;
    }

    .limited-access-composer__content {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
      width: 100%;
      min-width: 0;
    }

    .limited-access-composer__message-row {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      gap: 8px;
      min-width: 0;
    }

    .limited-access-composer__icon {
      flex-shrink: 0;
      display: block;
      width: 20px;
      height: 20px;
    }

    .limited-access-composer__title {
      margin: 0;
      min-width: 0;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #757575;
    }

    .limited-access-composer__reset {
      margin: 0;
      width: 100%;
      min-width: 0;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0;
      color: #7d5b00;
      text-align: left;
    }

    .limited-access-composer__cta {
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin: 0;
      padding: 8px 12px;
      border: 0;
      border-radius: 8px;
      background: #3570d2;
      font-family: "Lato", sans-serif;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #ffffff;
      cursor: pointer;
      text-align: center;
    }

    .limited-access-composer__cta:focus-visible {
      outline: 2px solid #3570d2;
      outline-offset: 2px;
    }
  </style>
</template>`;

styleElement.register("limited-access-composer-style");
